import React, { Component } from 'react';
import {connect} from 'react-redux';

class ForgotPassword extends Component {
  render() {
    return <div>
      <form className="login-form">
        <div className="form-group">
          <label htmlFor="exampleInputEmail1">Email <span className="red">*</span></label>
          <input type="email" className="form-control" id="exampleInputEmail1" placeholder="Email" />
        </div>
        <a href="/#/" className="btn btn-default">Reset my password</a>
      </form>
    </div>
  }
}

export default connect(
  state => ({}),
  dispatch => ({})
)(ForgotPassword);



/** WEBPACK FOOTER **
 ** ./src/components/ForgotPassword/index.js
 **/